import React, { useState, useEffect, useContext, useRef } from 'react';
import InputText from '../../Components/forms/inputText';
import Logo from '../../Components/logo';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux/es/exports';
import { loginUser, registerUser } from '../../features/user/userSlice';
import { Link, useNavigate } from 'react-router-dom';
import { getUserFromLocalStorage } from '../../utils/localStorage'
import LoadingAnimation from '../../Components/loadingAnimation';
import { AppConfigContext } from '../../Config/App';
import { LanguageContext } from '../../Data/Context/languageContext';
import BtnRounded from '../../Components/btn/btnRounded';

const initialState = {
    username: '',
    email: '',
    password: '',
    isMember: true,
    activation_key: ''
}

function Auth({ classes }) {
    const [values, setValues] = useState(initialState)
    const { isLoading } = useSelector((store) => store.user)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const user_session = getUserFromLocalStorage()
    const [isLoaded, setIsLoaded] = useState(false)
    const { navigate_to, uri_segment } = useContext(AppConfigContext);
    const { t } = useContext(LanguageContext);
    const form = useRef();

    const handleChange = (e) => {
        const inputName = e.target.name
        const value = e.target.value

        setValues({ ...values, [inputName]: value })
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const { username, email, password, isMember } = values;

        if (!username || !password || (!isMember && !username)) {
            toast.error(t("fillout_all_fields"))
            return
        }
        if (isMember) {
            dispatch(loginUser({ username: username, password: password }))
            return
        }

        if (!isMember) {
            dispatch(registerUser({ username, email, password }));
        }
    }

    const toggleMember = () => {
        setValues({ ...values, isMember: !values.isMember })
    }

    useEffect(() => {
        setTimeout(() => {
            if (user_session.user_id && uri_segment() === "auth") {
                navigate(navigate_to('dashboard'))
            }
            setIsLoaded(true)
        }, 500);

        // eslint-disable-next-line 
    }, [user_session])

    if (!isLoaded) {
        return <LoadingAnimation />
    } else {
        return (
            <div className={classes}>
                <div className={uri_segment() === "auth" ? "col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 mx-auto rounded-3 text-center custom-border" : ""}>
                    <Logo classes={'m-3'} />

                    <h3>{values.isMember ? t("login") : t("register")} </h3>
                    <form onSubmit={onSubmit} ref={form}>

                        {!values.isMember &&
                            <div className="form-group">
                                <InputText
                                    isForm={true}
                                    handleChange={handleChange}
                                    placeholder="Email"
                                    name="email">
                                    Email
                                </InputText>
                            </div>
                        }

                        <div className="form-group">
                            <InputText
                                isForm={true}
                                handleChange={handleChange}
                                placeholder="Username"
                                name="username">
                                {t("username")}
                            </InputText>
                        </div>

                        <div className="form-group">
                            <InputText
                                isForm={true}
                                handleChange={handleChange}
                                placeholder="Password"
                                name="password"
                                type="password">
                                {t("password")}
                            </InputText>
                        </div>

                        <div className="d-grid col text-center mb-3 ">
                            <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                {isLoading ? t("loading") : t("submit")}
                            </button>
                        </div>

                        <p>
                            {values.isMember ? t("not_a_member_yet") : t("already_a_member_yet")}

                            <button type='button' onClick={toggleMember} className='btn btn-link'>
                                {values.isMember ? t("register") : t("login")}</button>
                        </p>

                        <p>
                            <Link to={navigate_to("activate-account")}>
                                <BtnRounded>{t("activate_account")}</BtnRounded>
                            </Link>
                        </p>
                    </form>
                </div>
            </div>
        )
    }
}
export default Auth;